module.exports = __webpack_public_path__ + "static/media/mr-tire.2345a868.svg";